import { createSceneReducer } from 'reducers/reducers-util';
import depositsDataReducer from './deposits.data';
import depositsUiReducer from './deposits.ui';

export default createSceneReducer(depositsDataReducer, depositsUiReducer);
